import { render, staticRenderFns } from "./sql-settings.vue?vue&type=template&id=6781f93c&scoped=true"
import script from "./sql-settings.vue?vue&type=script&lang=js"
export * from "./sql-settings.vue?vue&type=script&lang=js"
import style0 from "./sql-settings.vue?vue&type=style&index=0&id=6781f93c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6781f93c",
  null
  
)

export default component.exports